import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { goldDictEl } from "@/lib/shop/products/gold";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/el/shop_/24kt-gold")({
  head: () => ({
    ...buildProductHead(goldDictEl),
    links: alternateLinkList("/shop/24kt-gold", "el"),
  }),
  component: () => <ProductPage dict={goldDictEl} />,
});
